import { Component, OnDestroy, OnInit, Output,ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {  Observable, Subscription } from 'rxjs';
import { SharedFormService } from 'src/app/shared-utility/services/shared-form.service';
import { SharedStateService } from 'src/app/shared-utility/services/shared-state.service';
import {  concatMap, map, mergeMap, switchMap  } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter } from 'protractor';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy{
   formGroup:FormGroup;
   loginSubscription: Subscription;
   accountSubscription: Subscription;
   formatsDateTest:string[];
   dateNow: Date; 
   chkIsPrimary: boolean = true;
   displayDialog: any;
   hashPrimary: { [indexer: string]: boolean } = {};
   userDetails:any
   key:boolean = true;
   forgotUsername:boolean=false;
   passwordRestSelected:boolean=false;
   usernameResetSelected:boolean=false;
   reset:string;
   showResetPasswordComponent:boolean=false;
   showPasswordIcon: boolean = false;
   showBanner: boolean = true;
   currentApplicationVersion:any;

  constructor(private fb: FormBuilder,
    private formData: SharedFormService,
    private sharedStateSvc: SharedStateService,
    private formSvc: SharedFormService,
    private googleAnalytics: GoogleAnalyticsService,
    private router: Router,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef) {
    this.formData.passwordResetRequired.subscribe((evt) =>
      this.showResetPasswordComponent = evt);
  }

    
  ngOnInit() {
    this.displayDialog = JSON.parse(sessionStorage.getItem('showBanner'));

    //Date formate
    this.formatsDateTest = ['MMM dd, yyyy'];
    this.dateNow = new Date();
    this.formGroup = this.fb.group({
      email: [null,Validators.required],
      password: [null, Validators.required]
    });
    if(this.sharedStateSvc.PrimaryState.loginMessage) {
      this.toastr.info(this.sharedStateSvc.PrimaryState.loginMessage);
      this.sharedStateSvc.clearState();
      this.sharedStateSvc.PrimaryState.loginMessage = '';
    }
    this.formData.hideLoader.next(false);
  }
  usernameReset(){
    this.router.navigate(["/credentials/reset-username"])
  }
  passwordReset(){
    this.router.navigate(["/credentials/reset-password"])
  }
  validateLoginBtn(): boolean {
    return !this.formGroup.valid;
  }

  togglePassword(): void{
    this.showPasswordIcon = !this.showPasswordIcon;
  }
  closeAlertBanner(){
    this.showBanner=false;
  }

  submitLogin(): void {
    this.SendSubmitButtonEvent();
    if(this.formGroup.valid){
      this.formData.hideLoader.next(true);
      const payload = {
        email: this.formGroup.get('email').value,
        password: this.formGroup.get('password').value,
        key:1
      };

     this.loginSubscription = this.sharedStateSvc.loginUser(payload).subscribe( authResp => {
        this.formData.hideLoader.next(false);
        localStorage.setItem('jwt', authResp.Payload.AccessToken);
        localStorage.setItem('username', payload.email);
        localStorage.setItem('usernameDetails', payload.email);
        localStorage.setItem('HasSecurityQuestionAnswered',authResp.Payload.HasSecurityQuestionAnswered);
        localStorage.setItem('ResetPasswordRequired',authResp.Payload.ResetPasswordRequired);
       localStorage.setItem('RefreshToken', authResp.Payload.RefreshToken);
       let refreshToken = this.sharedStateSvc.parseJwt(authResp.Payload.AccessToken);
       const expDate = new Date(refreshToken.exp * 1000);
       const currDate = new Date(refreshToken.iat * 1000);
       let refreshTime = this.sharedStateSvc.getTime(expDate) - this.sharedStateSvc.getTime(currDate);
       localStorage.setItem('expDate', expDate.toString());
       localStorage.setItem('refreshTime', refreshTime.toString());
        if(!authResp.Payload.HasSecurityQuestionAnswered ){
          this.router.navigateByUrl('/security-questions');
        }
        else if(authResp.Payload.ResetPasswordRequired){
          this.showResetPasswordComponent=true;
          this.cdr.detectChanges();
        }
        else{
          this.formSvc.setFilters([], []);
          this.formSvc.sendMessage('');
          this.router.navigate(['/dashboard']);
        }
        let loginStateValue = 'allProduct'
        this.sharedStateSvc.headerLogo.next(loginStateValue);
      },
      (error: any) => {
        this.formData.hideLoader.next(false);
        this.toastr.error(error);
      });
    }
  }
  
  setUpState(payload: any): Observable<any> {
    return this.sharedStateSvc.loginUser(payload).pipe(
      concatMap(authResp => this.sharedStateSvc.getAccountInfo(payload.email)
              .pipe(
                map(resp => ({ authResp, resp }))
              )
    ))
  }
  ngOnDestroy() {
    if(this.loginSubscription) {
      this.loginSubscription.unsubscribe(); 
    }
    if(this.accountSubscription) {
      this.accountSubscription.unsubscribe();
    }
    
  }

  checkPrimary(): void {
    if (this.chkIsPrimary) {
      this.hashPrimary["emailAddress0"] = true;
    } else {
      this.hashPrimary["emailAddress0"] = false;
    }
  }
 
  cancel(){
    sessionStorage.setItem('showBanner', 'false');
  }

  SendSubmitButtonEvent(){
    this.googleAnalytics.eventEmitter("click_on_login","login","","click",6)
  }
  SendForgetUsernameEvent(){
    this.googleAnalytics.eventEmitter("click_on_Forget_Username","login","","click",7);
  }
  SendForgetPasswordEvent(){
    this.googleAnalytics.eventEmitter("click_on_forget_Password","login","","click",8);
  }
  SendRegisterUserEvent(){
    this.googleAnalytics.eventEmitter("click_on_register_user","login","","click",9);
  }
  
}
